import { trackingApi } from '../../../../../apis/trackingApi'

export function sendFormData(formData, setSuccessData, setErrorData) {
  setSuccessData({ status: null, messages: null });
  setErrorData({ status: null, messages: null });
  var invalidForm = false;

  if (formData) {
    formData.fields.forEach(field => {
      if(field.isInvalid.status === true) invalidForm = true;

      if (field.inputEditable && (!(field.inputValue === "" || field.inputValue === null) && (/^\d{4}-\d{2}-\d{2}$/.test(field.inputValue)))) {
        field.inputValue += 'T00:00:00';
      }
    });
    
    if(!invalidForm) trackingApi.postTrackingForm(formData)
      .then((response) => {
        setSuccessData({
          status: 200,
          messages: response.messages
        });
      })
      .catch((error) => {
        console.error("Ocorreu um erro ao enviar o formulário:", error);

        setErrorData({
          status: error.response.status,
          messages: error.response.data.messages
        });
      });
  }
};
